import { create } from 'zustand';
import { supabase } from '@/lib/supabase';
import { AuthStore } from '@/lib/types/auth';

export const useAuthStore = create<AuthStore>((set) => ({
  user: null,
  loading: true,

  signIn: async (email: string) => {
    // Sign in with OTP and let Supabase handle whether the user exists
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: {
        shouldCreateUser: false,
      },
    });
    
    if (error) {
      // Check for specific error messages from Supabase
      if (error.message.includes("User not found") || 
          error.message.includes("Invalid login credentials") ||
          error.message.includes("Signups not allowed for otp")) {
          
        // Check if we need invites to register
        const { data: systemSettings } = await supabase
          .from('profiles')
          .select('invite_required')
          .limit(1)
          .single();
          
        if (systemSettings?.invite_required) {
          throw new Error('Gallery.cv is currently in early access. Please join our waitlist for an invitation.');
        }
        
        throw new Error('Email not found');
      }
      throw error;
    }
  },

  verifyOTP: async (email: string, token: string) => {
    const { error } = await supabase.auth.verifyOtp({
      email,
      token,
      type: 'email',
    });
    if (error) throw error;
  },

  signOut: async () => {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
    set({ user: null });
  },

  setUser: (user) => set({ user }),
  setLoading: (loading) => set({ loading }),
}));